// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"167":"8c3d5537","566":"f8bda244","822":"54ca7183"}[chunkId] + ".js";
};